import * as types from '../mutation-types';
import { unionState, toDateTimeString } from '../helpers';

const state = () => ({
	branchInfo: [],
});

const actions = {
	fetchAll({ commit }) {
		return axios.get('/api/settings/allbranch/info').then(response => {
			commit(types.STORE_BRANCH_INFO, response.data);
		});
	},

	create({ commit }, { branch_id, phone, address }) {
		const formData = new FormData();
		formData.append('branch_id', branch_id);
		formData.append('phone', phone);
		formData.append('address', address);


		return axios.post(`/api/settings/${branch_id}/branchinfo`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			commit(types.STORE_ONE_BRANCH_INFO, response.data);

			return response.data;
		});
	},

	fetch({ commit }, { id }) {
		return axios.get(`/api/settings/${id}/contact`).then(response => {
			commit(types.STORE_ONE_BRANCH_INFO, response.data);

			return response.data;
		});
	},

	delete({ commit }, { id }) {
		return axios.delete(`/api/settings/${id}/deletebranchinfo`).then(() => {
			commit(types.DELETE_BRANCH_INFO, id);
		});
	},

	update({ commit }, { id, branch_id, phone, address }) {
		const formData = new FormData();
		formData.append('branch_id', branch_id);
		formData.append('phone', phone);
		formData.append('address', address);


		formData.append('_method', 'PUT');

		return axios.post(`/api/settings/${id}/edit`, formData, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			commit(types.STORE_ONE_BRANCH_INFO, response.data);

			return response.data;
		});
	}
};

const mutations = {
	[types.STORE_BRANCH_INFO](state, values) {
		state.branchInfo = unionState(state.branchInfo, values);
	},

	// [types.STORE_ONE_BRANCH_INFO](state, id) {
	// 	state.branchInfo = unionState(state.branchInfo, id);
	// },

	[types.DELETE_BRANCH_INFO](state, id) {
		const value = state.branchInfo.find(p => p.id === id);
		value.deleted_at = toDateTimeString(new Date());
	},
};

const getters = {
	getById: state => id => state.branchInfo.find(c => c.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};